import React, { Component } from "react";

export default class PreviewCartItem extends Component {
    render() {
        const { image } = this.props;

        return (
            <div className="row py-2 px-3">
                <div className="col-2 text-center border-right d-flex justify-content-center align-items-center">
                    <img src={image} alt="ITEM IMG" style={{ width: "100%" }}/>
                </div>
                <div className="col-8 text-center border-right">
                    <b>{this.props.description}</b>
                </div>
                <div className="col-2">
                    {this.props.quantity}x<br/>{this.props.price}
                </div>
            </div>

            // <div className="row p-1 px-3">
            //     <div className="col-2 text-center border-right">
            //         <img src={image} alt="ITEM IMG"/>
            //     </div>
            //     <div className="col-8 text-center border-right">
            //         {this.props.description}
            //     </div>
            //     <div className="col-2">
            //         {this.props.quantity}x<br/>${this.props.price}
            //     </div>
            // </div>

        );
    }
}